// Social share-intent URLs for a blog post. Each opens the network's share
// composer pre-filled with the post URL (and title where the network supports
// it). The canonical post URL is built from the current origin so it works in
// any environment (local, preprod, prod). Crawlers read the real OG/Twitter
// cards from the server-rendered `/blogs/:slug` route (see backend app.py).

export function blogUrl(slug: string): string {
  return `${window.location.origin}/blogs/${slug}`;
}

export function linkedInShareUrl(slug: string): string {
  return `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(blogUrl(slug))}`;
}

export function xShareUrl(slug: string, title: string): string {
  const params = new URLSearchParams({ url: blogUrl(slug), text: title });
  return `https://twitter.com/intent/tweet?${params.toString()}`;
}

export function facebookShareUrl(slug: string): string {
  return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(blogUrl(slug))}`;
}

/** Copy the canonical post URL to the clipboard. Returns false if unsupported. */
export async function copyBlogLink(slug: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(blogUrl(slug));
    return true;
  } catch {
    return false;
  }
}
